import ls from "../SecureLS";
import { parseJSONField } from "./parseJSON";

export const getUserFromLS = () => {
  if (typeof window === "undefined") return null;
  const userLs = ls.get("user");
  const user = parseJSONField(userLs);
  if (!user) return null;
  return user;
};
